/**
 * Created by Andrey Okhotnikov on 02.06.2026
 * Email: hunterov1984@gmail.com
 */
import { Injectable, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Unsubscribe } from '@firebase/util';
import { initializeApp, getApp, getApps, FirebaseApp } from 'firebase/app';
import { getToken, getMessaging, onMessage, Messaging } from 'firebase/messaging';

import { OrNull } from '@app/utils/types.helper';
import { UserService } from '@app/services/user.service';
import { ApiService } from '@app/services/json-rest-api.service';
import { asyncInlineTry, isNotNil } from '@app/utils/functions.helper';
import { ApiMethod } from '@app/interfaces/api-request-body.interface';

@Injectable({
  providedIn: 'root',
})
export class FirebaseMessagingService {
  private restApi = inject(ApiService);
  private userSrv = inject(UserService);

  private app: FirebaseApp;
  private messaging: Messaging;
  // don't forget to change firebase-messaging-sw.js if you change this config
  readonly firebaseConfig = {
    apiKey: 'AIzaSyCoFSbo0mlQ1ZHomDgP8c60LwUKUAMOHeA',
    authDomain: 'cockpit-ng-a5c99.firebaseapp.com',
    projectId: 'cockpit-ng-a5c99',
    storageBucket: 'cockpit-ng-a5c99.firebasestorage.app',
    messagingSenderId: '49813513634',
    appId: '1:49813513634:web:f9835519d47963f9cf3efb',
    measurementId: 'G-2VL0RKQRYZ',
  };
  readonly vapidKey = 'BJINJ2jGW8BG2nym8G2LDWVl21Jmu59CgBNrMDyRDKEH_DDXsWIzZh19qrYganJ8ujiAuxUYRmTUyrAhawrBUh8';
  private unsubscribeFn: OrNull<Unsubscribe> = null;

  token: OrNull<string> = null;
  hasPermission = false;

  constructor() {
    this.app = getApps().length > 0 ? getApp() : initializeApp(this.firebaseConfig);
    this.messaging = getMessaging(this.app);

    this.userSrv.logout$.subscribe(() => {
      this.unsubscribeMessages();
      this.unregisterToken();
    });
  }

  async initNotifications() {
    if (Capacitor.isNativePlatform()) {
      console.warn('Firebase Cloud Notifications not initialized. Run in physical device');
      return;
    }
    await this.requestPermissions();

    await this.registerToken();

    this.listenMessages();
  }

  private async requestPermissions() {
    const permission = await Notification.requestPermission();
    this.hasPermission = permission === 'granted';
    console.log('Notification permission ' + permission);
  }

  private async registerToken() {
    this.token = await asyncInlineTry(() =>
      getToken(this.messaging, {
        vapidKey: this.vapidKey,
      }),
    );

    if (isNotNil(this.token)) {
      this.restApi
        .post(ApiMethod.mobileAgents, {
          TOKEN: this.token,
          PLATFORM: Capacitor.getPlatform(),
        })
        .subscribe({
          next: (result) => console.log('set mobile agent:', result),
          error: (error) => console.log('error set mobile agent:', error),
        });
    }
  }

  private async unregisterToken() {
    if (!Capacitor.isNativePlatform() && this.hasPermission) {
      this.restApi.delete(`${ApiMethod.mobileAgents}/${this.token}`).subscribe({
        next: () => console.log('mobile agent removed'),
        error: (error) => console.log('error remove mobile agent:', error),
      });
    }
  }

  private listenMessages(): void {
    // Unsubscribe from previous listener if exists to avoid multiple listeners
    this.unsubscribeMessages();

    this.unsubscribeFn = onMessage(this.messaging, (payload) => {
      console.log(payload);
    });
  }

  private unsubscribeMessages(): void {
    this.unsubscribeFn?.();
    this.unsubscribeFn = null;
  }
}
